import { Box, SxProps, Typography } from '@mui/material';
import { format } from 'date-fns';
import { t } from '../../constants/qrTranslations';
import { useLocale } from '../../contexts/locale.context';

type Props = {
  paidTime: number;
  sx?: SxProps;
};

const PaidLabel = ({ paidTime, sx }: Props) => {
  const { lang } = useLocale();

  return (
    <Box
      sx={{
        py: 1,
        px: 3,
        mx: 'auto',
        mt: 2,
        mb: 4,
        transform: 'rotate(-5deg)',
        borderStyle: 'solid',
        borderRadius: 1,
        borderWidth: 2,
        borderColor: (t) => t.palette.success.main,
        width: 160,
        ...sx,
      }}
    >
      <Typography textAlign="center" sx={{ color: (t) => t.palette.success.main, fontSize: 24 }}>
        {t.paid[lang].toUpperCase()}
      </Typography>

      {!!paidTime && (
        <Typography variant="body2" textAlign="center" sx={{ color: (t) => t.palette.success.main }}>
          {format(paidTime, 'dd.MM.yyyy HH:mm')}
        </Typography>
      )}
    </Box>
  );
};

export default PaidLabel;
